import React, { Component } from 'react';
import { ServiceCollectionParam } from "./ServiceCollection";
import MessageBox from "./MessageBox";
import { RegisteredUserRow } from "../common/dto/RegisteredUserRow";
import { Link } from "react-router-dom";
import MessageProvider from "../classes/MessageProvider";

interface State {
    rows: RegisteredUserRow[],
}

type Props = {
    eventId: string
}

export default class RegisteredListPage extends Component<ServiceCollectionParam & Props, {}> {

    messages = new MessageProvider(this.setState.bind(this));

    state: State = {
        rows: []
    };

    async componentDidMount() {
        await this.loadData();
    }

    async loadData() {

        const eventId = this.props.eventId;

        const rows = await this.props.services.dao.getRegisteredListForEvent(eventId);

        const missingNames = this.getMissingNames(rows);

        if (missingNames.length > 0) {
            this.messages.error(`Missing names: \n ${missingNames}`);
        }

        this.state.rows = rows;

        this.setState({});
    }

    private getMissingNames(rows: RegisteredUserRow[]): string {
        return rows.filter(row => row.declarationName !== row.ciName)
            .map(row => row.ciName)
            .join("\n");
    }

    async putCsvToClipboard() {

        const data = await this.props.services.dao
            .getRegistrationListCsv(this.props.eventId);

        await navigator.clipboard.writeText(data);
    }

    async putNamesToClipboard() {

        const data = await this.props.services.dao
            .getRegistrationListCsv(this.props.eventId);

        const names = data.split(/\r?\n/)
            .filter(line => line.length > 0)
            .map(line => line.split("\t")[0])
            .join("\n");

        await navigator.clipboard.writeText(names);
    }

    render() {
        return (
            <>
                <MessageBox messages={ this.messages.getMessages() } />

                <table className="table caption-top">
                    <caption>Registreerunud tudengid</caption>

                    <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Kasutajanimi</th>
                        <th scope="col">Nimi</th>
                        <th scope="col">Regstreerimiste arv</th>
                        <th scope="col">1. kt</th>
                        <th scope="col">2. kt</th>
                        <th scope="col">Senine hinne</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.state.rows.map((row, index) =>
                        <tr key={row.username}>
                            <td>{index + 1}</td>
                            <td>{row.username}</td>
                            <td className="no-wrap">
                                <Link to={`/results/${row.username}`}>{row.declarationName}</Link>
                            </td>
                            <td>{row.registrationCount}</td>
                            <td>{row.test1Points}</td>
                            <td>{row.test2Points}</td>
                            <td>{row.grade}</td>
                        </tr>)
                    }
                    </tbody>
                </table>

                <button
                    onClick={() => this.putCsvToClipboard()}
                    className="btn btn-success">Csv clipboard-i</button>
                &nbsp;
                <button
                    onClick={() => this.putNamesToClipboard()}
                    className="btn btn-success">Kopeeri nimed</button>
            </>);
    }

}
